import uniqueIds from '@/config/unique-ids.json'

import feixiangDoubleQuoteImg from '@/assets/login2/double-quote.png'
import feixiangsingleQuoteImg from '@/assets/login2/single-quote.png'
import feixiangrightTextImg from '@/assets/login2/right-text.png'
import feixiangrightText2Img from '@/assets/login2/right-text2.png'
import feixiangrightPlanet from '@/assets/login2/right-planet.png'
import feixiangrightLogo from '@/assets/login2/right-logo.png'
import feixiangsingleToDouble from '@/assets/login2/single2double.png'
import feixiangdoubleTosingle from '@/assets/login2/double2single.png'
import feixiangBg1 from '@/assets/login2/right-bg1.png'
import feixiangBgu from '@/assets/login2/right-bg-u.png'

import hsmsfQuote from '@/assets/hsmsf/quote.png'
import hsmsfQuote2 from '@/assets/hsmsf/q22.png'
import hsmsfText1 from '@/assets/hsmsf/right-text.png'
import hsmsfRightPlanet from '@/assets/hsmsf/right-planet.png'
import hsmsfRightLogo from '@/assets/hsmsf/right-logo.png'
import hsmsfsingleToDouble from '@/assets/hsmsf/logo2quote.png'
import hsmsfdoubleTosingle from '@/assets/hsmsf/quote2logo.png'
import hsmsfBg1 from '@/assets/hsmsf/right-bg-1.png'
import hsmsfBgu from '@/assets/hsmsf/right-bg-u.png'

import pgqjywyhQuote from '@/assets/pgqjywyh/quote.png'
import pgqjywyhQuote2 from '@/assets/pgqjywyh/q22.png'
import pgqjywyhText1 from '@/assets/pgqjywyh/right-text.png'
import pgqjywyhRightPlanet from '@/assets/pgqjywyh/right-planet.png'
import pgqjywyhRightLogo from '@/assets/pgqjywyh/right-logo.png'
import pgqjywyhsingleToDouble from '@/assets/pgqjywyh/logo2quote.png'
import pgqjywyhdoubleTosingle from '@/assets/pgqjywyh/quote2logo.png'
import pgqjywyhBg1 from '@/assets/pgqjywyh/right-bg-1.png'
import pgqjywyhBgu from '@/assets/pgqjywyh/right-bg-u.png'

import zhzxjsDoubleQuoteImg from '@/assets/zhzxjs/double-quote.png'
import zhzxjsSingleQuoteImg from '@/assets/zhzxjs/single-quote.png'
import zhzxjsRightPlanet from '@/assets/zhzxjs/right-planet.png'
import zhzxjsRightLogo from '@/assets/zhzxjs/right-logo.png'
import zhzxjsSingleToDouble from '@/assets/zhzxjs/single2double.png'
import zhzxjsDoubleToSingle from '@/assets/zhzxjs/double2single.png'
import zhzxjsBg1 from '@/assets/zhzxjs/right-bg-1.png'
import zhzxjsBgu from '@/assets/zhzxjs/right-bg-u.png'

const hsmsfText2 = hsmsfText1
const pgqjywyhText2 = pgqjywyhText1

export const LoginRightConfig = {
  bgMap: {
    [uniqueIds.FEIXIANG_UNIQUE_ID.id]: {
      bgColor: 'rgba(224, 242, 255, .8)',
      bg1: feixiangBg1,
      bgu: feixiangBgu,
    },
    [uniqueIds.HSMSF_UNIQUE_ID.id]: {
      bgColor: 'rgba(255, 247, 232, .8)',
      bg1: hsmsfBg1,
      bgu: hsmsfBgu,
    },
    [uniqueIds.PGQJYWYH_UNIQUE_ID.id]: {
      bgColor: '#FBF8E9',
      bg1: pgqjywyhBg1,
      bgu: pgqjywyhBgu,
    },
    [uniqueIds.ZHZXJS_UNIQUE_ID.id]: {
      bgColor: 'rgba(224, 242, 255, .8)',
      bg1: zhzxjsBg1,
      bgu: zhzxjsBgu,
    },
    [uniqueIds.JIANGUAN_UNIQUE_ID.id]: {
      bgColor: 'rgba(224, 242, 255, .8)',
      bg1: feixiangBg1,
      bgu: feixiangBgu,
    },
    [uniqueIds.FLYING_UNIQUE_ID.id]: {
      bgColor: 'rgba(224, 242, 255, .8)',
      bg1: feixiangBg1,
      bgu: feixiangBgu,
    },
    [uniqueIds.SUZHOUYIJIAXUEYUAN_UNIQUE_ID.id]: {
      bgColor: 'rgba(224, 242, 255, .8)',
      bg1: feixiangBg1,
      bgu: feixiangBgu,
    },
  },
  imgMap: {
    [uniqueIds.FEIXIANG_UNIQUE_ID.id]: {
      doubleQuoteImg: feixiangDoubleQuoteImg,
      singleQuoteImg: feixiangsingleQuoteImg,
      rightTextImg: feixiangrightTextImg,
      rightText2Img: feixiangrightText2Img,
      rightPlanet: feixiangrightPlanet,
      rightLogo: feixiangrightLogo,
      singleToDouble: feixiangsingleToDouble,
      doubleTosingle: feixiangdoubleTosingle,
    },
    [uniqueIds.HSMSF_UNIQUE_ID.id]: {
      doubleQuoteImg: hsmsfQuote,
      singleQuoteImg: hsmsfQuote2,
      rightTextImg: hsmsfText1,
      rightText2Img: hsmsfText2,
      rightPlanet: hsmsfRightPlanet,
      rightLogo: hsmsfRightLogo,
      singleToDouble: hsmsfsingleToDouble,
      doubleTosingle: hsmsfdoubleTosingle,
    },
    [uniqueIds.PGQJYWYH_UNIQUE_ID.id]: {
      doubleQuoteImg: pgqjywyhQuote,
      singleQuoteImg: pgqjywyhQuote2,
      rightTextImg: pgqjywyhText1,
      rightText2Img: pgqjywyhText2,
      rightPlanet: pgqjywyhRightPlanet,
      rightLogo: pgqjywyhRightLogo,
      singleToDouble: pgqjywyhsingleToDouble,
      doubleTosingle: pgqjywyhdoubleTosingle,
    },
    [uniqueIds.ZHZXJS_UNIQUE_ID.id]: {
      doubleQuoteImg: zhzxjsDoubleQuoteImg,
      singleQuoteImg: zhzxjsSingleQuoteImg,
      rightPlanet: zhzxjsRightPlanet,
      rightLogo: zhzxjsRightLogo,
      singleToDouble: zhzxjsSingleToDouble,
      doubleTosingle: zhzxjsDoubleToSingle,
    },
    [uniqueIds.JIANGUAN_UNIQUE_ID.id]: {
      doubleQuoteImg: feixiangDoubleQuoteImg,
      singleQuoteImg: feixiangsingleQuoteImg,
      rightTextImg: feixiangrightTextImg,
      rightText2Img: feixiangrightText2Img,
      rightPlanet: feixiangrightPlanet,
      rightLogo: feixiangrightLogo,
      singleToDouble: feixiangsingleToDouble,
      doubleTosingle: feixiangdoubleTosingle,
    },
    [uniqueIds.FLYING_UNIQUE_ID.id]: {
      doubleQuoteImg: feixiangDoubleQuoteImg,
      singleQuoteImg: feixiangsingleQuoteImg,
      rightTextImg: feixiangrightTextImg,
      rightText2Img: feixiangrightText2Img,
      rightPlanet: feixiangrightPlanet,
      rightLogo: feixiangrightLogo,
      singleToDouble: feixiangsingleToDouble,
      doubleTosingle: feixiangdoubleTosingle,
    },
    [uniqueIds.SUZHOUYIJIAXUEYUAN_UNIQUE_ID.id]: {
      doubleQuoteImg: feixiangDoubleQuoteImg,
      singleQuoteImg: feixiangsingleQuoteImg,
      rightTextImg: feixiangrightTextImg,
      rightText2Img: feixiangrightText2Img,
      rightPlanet: feixiangrightPlanet,
      rightLogo: feixiangrightLogo,
      singleToDouble: feixiangsingleToDouble,
      doubleTosingle: feixiangdoubleTosingle,
    },
  },
  textImgList: {
    [uniqueIds.FEIXIANG_UNIQUE_ID.id]: [feixiangrightTextImg, feixiangrightText2Img],
    [uniqueIds.HSMSF_UNIQUE_ID.id]: [hsmsfText1],
    [uniqueIds.PGQJYWYH_UNIQUE_ID.id]: [pgqjywyhText1],
    [uniqueIds.ZHZXJS_UNIQUE_ID.id]: [],
    [uniqueIds.JIANGUAN_UNIQUE_ID.id]: [feixiangrightTextImg, feixiangrightText2Img],
    [uniqueIds.FLYING_UNIQUE_ID.id]: [feixiangrightTextImg, feixiangrightText2Img],
    [uniqueIds.SUZHOUYIJIAXUEYUAN_UNIQUE_ID.id]: [],
  },
  textImgWidth: {
    [uniqueIds.FEIXIANG_UNIQUE_ID.id]: undefined,
    [uniqueIds.HSMSF_UNIQUE_ID.id]: '38%',
    [uniqueIds.PGQJYWYH_UNIQUE_ID.id]: undefined,
    [uniqueIds.ZHZXJS_UNIQUE_ID.id]: undefined,
    [uniqueIds.JIANGUAN_UNIQUE_ID.id]: undefined,
    [uniqueIds.FLYING_UNIQUE_ID.id]: undefined,
    [uniqueIds.SUZHOUYIJIAXUEYUAN_UNIQUE_ID.id]: undefined,
  },
  titleText: {
    [uniqueIds.SUZHOUYIJIAXUEYUAN_UNIQUE_ID.id]: '易加AI作文',
  },
}
